import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import link from '../../assets/link_2.svg';
import addIcon from '../../assets/add.svg';
import poSearchFiltersStyles from './tapa.module.css';
import commonStyles from '../common/common.module.css';

import Grid from '@material-ui/core/Grid';
import { KeyboardDatePicker } from '@material-ui/pickers';
import OrderDashboard from '../../models/OrderDashboard';

const styles = (theme: Theme) =>
  createStyles({
    blue: {
      color: 'var(--primaryblue)',
    },
    manualEntryBtn: {
      fontSize: '50px',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    linkButton: {
      backgroundColor: 'var(--primaryblue)',
      padding: '8px',
      borderRadius: '8px',
      width: '24px',
      cursor: 'pointer',
      boxSizing: 'content-box'
    },
    marginBottom: {
      marginBottom: '30px',
    },
    linkButton2: {
      background: 'transparent',
      border: 'none',
      '&:disabled img': {
        backgroundColor: 'var(--disabled)',
        pointerEvent: 'none',
      }
    },
  });

interface TapaHeaderComponentProps {
  classes: any;
  openForm: (type: string) => void;
  date: any;
  dateChange: (type: string, date: any) => void;
  selectedOrder: OrderDashboard;
}

const tapaHeaderComponent = (props: TapaHeaderComponentProps) => {
  const { classes } = props;
  return (
    <div className={ poSearchFiltersStyles.mainWrapper }>
      <div className={ poSearchFiltersStyles.titleWrapper_sm }></div>
      <div className={ [poSearchFiltersStyles.titleWrapper,poSearchFiltersStyles.flexAndRow].join(' ') }>
        <div className={ poSearchFiltersStyles.buttonWrapper }>
          <Grid container	direction='row' className={ `${poSearchFiltersStyles.iconWrapper} ${classes.marginBottom}` }>
            <Grid item xs={6}>
              <Grid container	direction='column' className={ poSearchFiltersStyles.alignMiddle }>
                <Grid item className={ poSearchFiltersStyles.fs0 }>
                  <button
                    className={ classes.linkButton2 }
                    disabled={ !props.selectedOrder.id }
                    onClick={ () => props.openForm('linkorder') }>
                    <img
                      alt='logo'
                      src={ link }
                      className={ props.classes.linkButton }
                    />
                  </button>
                </Grid>
                <Grid item>
                  <p className={ poSearchFiltersStyles.btnName }>
                    New Inspection Linked To Order
                  </p>
                </Grid>
              </Grid>
            </Grid>

            <Grid item className= { `${ commonStyles.searchWrapperOuter } ${poSearchFiltersStyles.tapaSearch}` }>
              <div className={ `${ commonStyles.searchWrapper } ${ commonStyles.inputLabelWrapper }`} >
                <div className={ commonStyles.inputLabel }>
                  Inspection Date
                </div>
                <KeyboardDatePicker
                  autoOk
                  label=''
                  className={ `${classes.dateInput} ${classes.ipField}` }
                  value={ props.date }
                  format={'DD MMM YYYY'}
                  onChange={ (date: any) => props.dateChange('forms', date) }
                  InputProps={{
                    className: classes.blue,
                    classes: { input: classes.inputtextField },
                  }}
                  InputLabelProps={{
                    className: classes.blue,
                  }}
                  inputVariant='outlined'
                />
              </div>
            </Grid>

            <Grid item xs={6}>
              <Grid
                container
                direction='column'
                className={ poSearchFiltersStyles.alignMiddle }>
                <Grid item className={ poSearchFiltersStyles.fs0 }>
                  <img
                    alt='logo'
                    src={ addIcon }
                    className={ props.classes.manualEntryBtn }
                    onClick={ () => props.openForm('createform') }
                  />
                </Grid>
                <Grid item>
                  <p className={ poSearchFiltersStyles.btnName }>
                    New Independent Inspection
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(tapaHeaderComponent);
